import { datetime } from '@yoop/datetime';
import type { AppDate } from '@yoop/datetime';

export interface UpgradeDirectionSummary {
  [otherReceiptId: string]: {
    count: number;
    date: AppDate;
    inventoryItemIds: number[];
  };
}

interface OfferUpgradeSummary {
  from?: UpgradeDirectionSummary;
  to?: UpgradeDirectionSummary;
}

interface OfferUpgradeMap {
  [offerId: string]: OfferUpgradeSummary;
}

interface UpgradeInventoryChangeItem {
  inventoryItemId: number;
  changeFromOfferId: number;
  changeToOfferId: number;
  changeFromCustomerOrderId: number;
  changeToCustomerOrderId: number;
  purchaseTimestamp: string;
}

export const getOfferUpgradeMap = (receipt: {
  customerOrderId: number;
  inventoryChangeData?: { inventoryDataList?: UpgradeInventoryChangeItem[] };
}): OfferUpgradeMap => {
  return (
    receipt.inventoryChangeData?.inventoryDataList?.reduce(
      (
        changes,
        {
          changeFromOfferId,
          changeToOfferId,
          purchaseTimestamp,
          changeToCustomerOrderId,
          changeFromCustomerOrderId,
          inventoryItemId,
        },
      ) => {
        let thisOfferId, thatReceiptId, directionKey: 'to' | 'from';
        if (receipt.customerOrderId === changeFromCustomerOrderId) {
          directionKey = 'to';
          thisOfferId = `${changeFromOfferId}`;
          thatReceiptId = `${changeToCustomerOrderId}`;
        } else {
          directionKey = 'from';
          thisOfferId = `${changeToOfferId}`;
          thatReceiptId = `${changeFromCustomerOrderId}`;
        }
        const thisOffer = changes[thisOfferId] ?? ({ [directionKey]: {} } as OfferUpgradeSummary);
        const thisDirection: UpgradeDirectionSummary = thisOffer[directionKey] ?? {};
        const thatReceipt = thisDirection[thatReceiptId] ?? {
          count: 0,
          date: datetime.parse(purchaseTimestamp),
          inventoryItemIds: [],
        };
        thatReceipt.count++;
        thatReceipt.inventoryItemIds.push(inventoryItemId);
        return {
          ...changes,
          [thisOfferId]: {
            ...thisOffer,
            [directionKey]: {
              ...thisOffer[directionKey],
              [thatReceiptId]: thatReceipt,
            },
          },
        };
      },
      {} as OfferUpgradeMap,
    ) ?? {}
  );
};
